/** @jsxRuntime classic */
/** @jsx jsx */
import { Box, Link } from '@bottlebooks/gatsby-theme-base';
import { jsx } from 'theme-ui';
import useLink from '../../useLink';

export default function MenuItem({ url, type, name, counter, ...rest }) {
  const link = useLink();
  // If there is no custom URL, use the paths to go to the correct URLs.
  const to = url || link[type]?.() || `/${type}`;
  return (
    <Link
      // We rely on the Link component to figure out if the link is internal or external.
      to={to}
      _suppressExternalLinkWarning
      variant="menu"
      activeClassName="bb-active"
      partiallyActive={to !== '/'} // If we link to the root, we don't want the menu item to be marked as active. For other pages, we want the whole section to be highlighted.
      sx={{ position: 'relative', '&.bb-active': { color: 'primary' } }}
      {...rest}
    >
      {name}
      {counter != null && (
        <Box
          sx={{
            position: 'absolute',
            top: 0,
            right: 0,
            color: 'primary',
            fontSize: 'smallest',
          }}
        >
          {counter}
        </Box>
      )}
    </Link>
  );
}
